<script>
import SpinLoader from '@/components/SpinLoader'

export default {
    name: "Pay",
    components: {SpinLoader},
    data() {
        return {
            games: [],
            selectedGame: "gta5",
            selectedPeriod: "3 месяца",
            selectedPeriodSlug: "3m",
            firstBlockCompleted: false,
            checkboxReady: false,
            isDropdownVisible: false,
            isDropdownTierVisible: false,
            loading: false,
            selectedSubscription: null,
            paymentMethod: 0,
            email: ''
        }
    },
    watch: {
        paymentMethod() {
            this.updateUrl()
        }
    },
    computed: {
        selectedGameData() {
            return this.games.find(game => game.slug === this.selectedGame)
        },
        price() {
            return this.selectedGameData.items.find(item => item.slug === this.selectedPeriodSlug).price
        },
        paymentDate() {
            const periodSeconds = {
                '1m': 2592000,
                '3m': 2592000 * 3,
                '6m': 2592000 * 6,
                '12m': 2592000 * 12
            }

            return this.formatDate(new Date(Date.now() + (periodSeconds[this.selectedSubscription.slug] * 1000)))
        }
    },
    methods: {
        formatDate(d) {
            return ("0" + d.getDate()).slice(-2) + "." + ("0"+(d.getMonth()+1)).slice(-2) + "." +
                d.getFullYear()
        },
        getGameTitleBySlug(slug) {
            const game = this.games.find(game => game.slug === slug)
            return game ? game.title : null
        },
        getTierTitleBySlug(slug) {
            const game = this.games.find(game => game.slug === slug)
            return game ? game.tierTitle : null
        },
        getGameIconBySlug(slug) {
            const game = this.games.find(game => game.slug === slug)
            return game ? game.icon : null
        },
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible
        },
        toggleTierDropdown() {
            this.isDropdownTierVisible = !this.isDropdownTierVisible
        },
        updateUrl() {
            this.$router.replace({
                path: '/pay',
                query: {
                    game: this.$route.query.game,
                    period: this.$route.query.period,
                    tier: this.$route.query.tier,
                    method: this.paymentMethod
                }
            })
        },
        selectGame(slug) {
            const game = this.games.find(game => game.slug === slug);
            if (game) {
                this.selectedGame = slug
            }
        },
        isValidEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return regex.test(email)
        },
        pay() {
            if(!this.email.trim()) return alert('Введите e-mail!')
            if(!this.checkboxReady) return alert('Вы не согласились с условиями оферты и политикой конфиденциальности')
            if(!this.isValidEmail(this.email)) return alert('Неверный e-mail!')

            window.location.href = `/payment-redirect?game=${this.$route.query.game}&tier=${this.$route.query.tier}&period=${this.$route.query.period}&method=${this.paymentMethod}&email=${this.email}&hash=${localStorage.getItem('hash')}`
        }
    },
    async created() {
        this.loading = true

        try {
            const response = await fetchServer('/subscriptions')
            if(response['err']) {
                alert('Ошибка! Попробуйте позже')
                return
            }

            if(response['internalError']) {
                alert('Ошибка! Попробуйте позже')
                return
            }

            for(let subscription of response) {
                const gamePeriods = [
                    { period: `${this.__('1 месяц')}`, price: !subscription.discount ? subscription.prices[0] : subscription.discountPrices[0], slug: "1m", discount: subscription.discount || 0 },
                    { period: `${this.__('3 месяца')}`, price: !subscription.discount ? subscription.prices[1] : subscription.discountPrices[1], slug: "3m", discount: subscription.discount || 12 },
                    { period: `${this.__('6 месяцев')}`, price: !subscription.discount ? subscription.prices[2] : subscription.discountPrices[2], slug: "6m", discount: subscription.discount || 22 },
                    { period: `${this.__('1 год')}`, price: !subscription.discount ? subscription.prices[3] : subscription.discountPrices[3], slug: "12m", discount: subscription.discount || 32 },
                ]

                this.games.push({
                    tier: subscription.tier,
                    tierTitle: subscription.tier === 1 ? 'Game Plus': 'Cloud Premium',
                    title: subscription.title || this.__('Все игры'),
                    slug: subscription.game,
                    icon: subscription.title ? require(`@/assets/images/gameIcons/${subscription.game}.png`) : require('@/assets/images/gameIcons/all.svg'),
                    items: gamePeriods
                })
            }

            this.loading = false

            // console.log(this.games)
            const game = this.games.find(game => game.tier == this.$route.query.tier && game.slug == this.$route.query.game)
            if(!game) {
                this.$router.push('/')
                return
            }

            this.selectedSubscription = game?.items?.find(item => item.slug == this.$route.query.period)
            if(!this.selectedSubscription) {
                this.$router.push('/')
                return
            }

        } catch (e) {

        } finally {
            this.loading = false
        }
    },
    mounted() {

    }
}
</script>

<template>
    <section class="subscribe">
        <SpinLoader :size="48" v-if="loading" />
        <div class="subscribe-box" v-else>
            <div class="sub-text-container">
                {{__('Выбор способа оплаты')}}
                <div class="divider"></div>
            </div>
            <div class="sub-select-container">
                {{ __('Выберите удобный вам метод:') }}
                <div class="payment-container">
                    <div class="payment-method" :class="{ active: paymentMethod === 0 }" @click="paymentMethod = 0">
                        <img src="@/assets/icons/payments/ru_card.svg" class="payment-icon">
                        <div class="payment-method-title">{{__('Банковская карта | Россия')}}</div>
                    </div>
                    <div class="payment-method" :class="{ active: paymentMethod === 1 }" @click="paymentMethod = 1">
                        <img src="@/assets/icons/payments/crypto.svg" class="payment-icon">
                        <div class="payment-method-title">{{__('Криптовалюта')}}</div>
                    </div>
                </div>
            </div>
            <div class="sub-select-container">
                {{ __('Укажите E-mail адрес:') }}
                <input type="email" v-model="email" class="mail-input" placeholder="E-mail">
            </div>
            <div class="checkbox-container">
                <div class="checkbox" @click="checkboxReady = !checkboxReady">
                    <svg v-if="checkboxReady" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.67292 8.61873L10.0333 4.25832C10.1394 4.15137 10.2631 4.0979 10.4045 4.0979C10.5459 4.0979 10.6701 4.15137 10.7771 4.25832C10.884 4.36526 10.9375 4.48961 10.9375 4.63136C10.9375 4.77311 10.8859 4.89556 10.7828 4.99871L6.05208 9.74165C5.94601 9.84859 5.8223 9.90207 5.68094 9.90207C5.53948 9.90207 5.41528 9.84859 5.30833 9.74165L3.22292 7.65623C3.11597 7.54929 3.0625 7.42533 3.0625 7.28436C3.0625 7.14339 3.11597 7.01943 3.22292 6.91248C3.32986 6.80554 3.45465 6.75207 3.59727 6.75207C3.7398 6.75207 3.86293 6.80554 3.96667 6.91248L5.67292 8.61873Z" fill="white"/>
                    </svg>
                </div>
                <div class="checkbox-text">
                    <span v-html="__('Я ознакомился и согласен с <a class=\'checkbox-click-text\' href=\'/user-agreement\' target=\'_blank\'>условиями оферты</a> и <a class=\'checkbox-click-text\' href=\'/privacy-policy\' target=\'_blank\'>политикой конфиденциальности</a>')"></span>
                </div>
            </div>
            <div class="next-payment" v-if="paymentMethod === 0">{{__('Следующая дата списания:')}} {{paymentDate}}</div>
            <div class="sub-button" @click="pay" v-if="paymentMethod === 0">{{ __('Оплатить') }} {{ selectedSubscription.price }}₽</div>
            <div class="sub-button" @click="pay" v-else-if="paymentMethod === 1">{{ __('Оплатить') }} {{ (selectedSubscription.price / 100 + (selectedSubscription.price / 100) * 0.1).toFixed(2) }}$</div>
        </div>
    </section>
</template>

<style scoped>
.subscribe {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
    user-select: none;
}

.subscribe-box {
    display: flex;
    background: var(--bg-secondary);
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.divider {
    background: #323030;
}

.sub-text-container {
    display: flex;
    flex-direction: column;
    color: var(--text-primary);
    font-weight: 700;
}

.sub-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    transition: 0.2s ease;

    background: var(--bg-accent);
}

.sub-box:hover {
    cursor: pointer;
    background: var(--button-main);
}

.sub-type {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-primary);
    font-weight: 600;
}

.sub-select-container {
    display: flex;
    flex-direction: column;
    font-weight: 600;
    color: var(--text-accent);
}

.sub-time-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--bg-accent);
    box-sizing: border-box;
}

.sub-price-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.sub-price-sale {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-main);
}

.sub-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-main);
    transition: 0.25s ease;
}

.radio-css {
    background: #0077FF;
}

.sub-time-box {
    transition: 0.25s ease;
}

.sub-time-box:hover {
    background: var(--button-main);
    cursor: pointer;
}

.sub-time-box.selected {
    background: var(--button-main);
}

.sub-button:hover {
    background: #6143CE;
    cursor: pointer;
}

.payment-method {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: var(--bg-accent);

    transition: 0.25s ease;
}

.payment-method:hover {
    background: var(--color-main);
    cursor: pointer;
}

.payment-method.active {
    background: var(--color-main);
    cursor: pointer;
}

.payment-container {
    display: flex;
    flex-direction: row;
}

.mail-input {
    font-family: 'TT Interfaces';
    font-weight: 600;

    border: 1px solid rgba(255, 255, 255, 0.05);
    background: var(--bg-accent, #0D0D0D);
}

input, input:focus, input:active, textarea, textarea:focus, textarea:active {
    background: transparent;
    outline: none;
    border: 0;
    padding: 0;
    margin: 0;
    user-select: auto;
    font-family: 'TT Interfaces', sans-serif;
    resize: none;
}

.checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #151515;
    box-shadow: 0px 2px 2px 0px rgba(27, 28, 29, 0.12);

    transition: 0.2s ease;
}

.checkbox:hover {
    cursor: pointer;
}

.checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.checkbox-text {
    color: var(--text-secondary);
    font-weight: 600;
}

.sub-context-menu {
    position: absolute;
    top: 50px;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: rgba(6, 6, 6, 0.80);
    backdrop-filter: blur(27px);
}

.context-game-button {
    display: flex;
    align-items: center;
    color: var(--text-secondary);

    transition: 0.15s ease;
}

.context-game-button:hover {
    background: rgba(29, 29, 29, 0.60);
    backdrop-filter: blur(27px);
    cursor: pointer;
    color: var(--text-primary);
}

.checkbox-click-text {
    color: var(--text-primary) !important;
    transition: 0.25s ease;
}

.checkbox-click-text:hover {
    cursor: pointer;
    color: var(--text-accent);
}

@media (min-width: 320px) {

}

@media (min-width: 464px) {

}

@media (min-width: 744px) {

}

@media (min-width: 984px) {

}

@media (min-width: 1248px) {
    .subscribe {
        background-image: url("@/assets/images/subscribe1244.png");
        height: 940px;
    }

    .subscribe-box {
        width: 467px;
        padding: 44px 28px;
        border-radius: 15px;
        gap: 30px;
    }

    .divider {
        width: 410px;
        height: 1px;
    }

    .sub-text-container {
        gap: 24px;
        font-size: 18px;
    }

    .sub-box {
        position: relative;
        padding: 22px;
        border-radius: 12px;
        width: 410px;
        height: 46px;
    }

    .sub-type {
        gap: 6px;
        font-size: 16px;
    }

    .sub-select-container {
        gap: 12px;
        font-size: 16px;
    }

    .sub-time-box {
        border-radius: 12px;
        width: 410px;
        height: 46px;
        padding: 22px;
    }

    .sub-price-container {
        gap: 12px;
    }

    .sub-price-sale {
        filter: drop-shadow(0px 4px 24px rgba(120, 83, 255, 0.50));
        border-radius: 6px;
        padding: 3px 4px;
        font-size: 13px;
    }

    .sub-button {
        width: 410px;
        height: 44px;
        border-radius: 9px;
    }

    .gameiconimage {
        height: 20px;
        width: 20px;
    }

    .payment-method {
        width: 195px;
        height: 107px;
        border-radius: 15px;

        gap: 8px;
    }

    .payment-method-title {
        text-align: center;
        font-size: 14px;
        width: 145px;
    }

    .payment-container {
        gap: 12px;
    }

    .mail-input {
        width: 410px;
        height: 46px;
        border-radius: 12px;
        padding: 22px;

        color: var(--text-primary);
    }

    input, input:focus, input:active, textarea, textarea:focus, textarea:active {
        padding: 22px;
        border: 1px solid rgba(255, 255, 255, 0.05);
        background: var(--bg-accent, #0D0D0D);
    }

    .next-payment {
        width: 409px;
        font-size: 15px;
        font-weight: 500;
        opacity: 0.6;
    }

    .checkbox {
        width: 16px;
        height: 16px;

        border-radius: 2.6px;
    }

    .checkbox-container {
        gap: 12px;
    }

    .checkbox-text {
        width: 379px;
        font-size: 16px;
    }

    .sub-context-menu {
        border-radius: 12px;
        padding: 8px 8px;
    }

    .context-game-button {
        width: 396px;
        height: 39px;
        border-radius: 12px;
        padding: 12px;
        gap: 12px;
    }

    .context-icon {
        height: 20px;
        width: 20px;
    }
}
</style>